// exportCsvData.js
import { dateformation } from "src/components/date-format-mdy";
export const getCsvData = (tableData = {}) => {
    return tableData?.map((row) => {
        const filteredRow = {};
        const fields = {
            'date': dateformation(row?.invoice_date) || dateformation(row?.date_of_receipt) || dateformation(row?.date),
            'bank_information': row?.bank_information?.bank_name,
            'transaction_type': row?.account_chart?.account_type?.name,
            'source': row.source?.name,
            'description': row?.description || row.notes,
            'expense': row?.debit,
            'income': row?.credit,
            'balance': row?.balance,
        };
        Object.keys(fields).forEach((key) => {
            if (key !== 'actions') {
                filteredRow[key] = fields[key];
            }
        });
        return filteredRow;
    });
};
